var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(this.$store.state.loading),expression:"this.$store.state.loading"}],staticClass:"chrray-main"},[_c('sidebar',{on:{"change":_vm.handleChange}}),_c('monitor-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }